import { render, staticRenderFns } from "./HomeService2.vue?vue&type=template&id=7b989f2e&scoped=true&"
import script from "./HomeService2.vue?vue&type=script&lang=js&"
export * from "./HomeService2.vue?vue&type=script&lang=js&"
import style0 from "./HomeService2.vue?vue&type=style&index=0&id=7b989f2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b989f2e",
  null
  
)

export default component.exports